class StickyAddToCart {
  constructor() {
    this.mainAddToCartBtn = document.querySelector('[data-js-product-add-to-cart]');
    this.stickyContainer = document.querySelector('[data-sticky-cart]');
    
    if (!this.mainAddToCartBtn || !this.stickyContainer) return;
    
    this.stickyAddToCartBtn = this.stickyContainer.querySelector('[data-sticky-add-to-cart-btn]');
    this.stickyPrice = this.stickyContainer.querySelector('[data-sticky-price]');
    this.productForm = document.querySelector('[data-js-product-form]');
    this.productVariants = document.querySelector('[data-main-product-variants]');
    
    // Track if the main button has been scrolled past
    this.hasScrolledPastMainButton = false;
    
    this.init();
  }

  init() {
    // Listen for scroll events to show/hide the sticky button
    window.addEventListener('scroll', this.checkButtonVisibility.bind(this));
    
    // Add click event to the sticky button
    if (this.stickyAddToCartBtn) {
      this.stickyAddToCartBtn.addEventListener('click', this.addToCart.bind(this));
    }
    
    // Listen for variant changes to update the sticky button
    if (this.productVariants) {
      this.productVariants.addEventListener('variant:change', this.updateStickyButton.bind(this));
    }
    
    // Initial check on page load
    this.checkButtonVisibility();
  }

  checkButtonVisibility() {
    if (!this.mainAddToCartBtn || !this.stickyContainer) return;
    
    const buttonRect = this.mainAddToCartBtn.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    
    // Check if the top of the button is above the bottom of the viewport
    // This means we've scrolled past the button or it's partially visible at the top
    const hasScrolledPastTop = buttonRect.top < 0;
    
    // Check if the button is completely out of view at the top
    const isCompletelyOutOfView = buttonRect.bottom <= 0;
    
    // If we've scrolled past the button, mark it
    if (isCompletelyOutOfView) {
      this.hasScrolledPastMainButton = true;
    }
    
    // Only show sticky button if:
    // 1. We have already scrolled past the main button at some point AND
    // 2. The main button is currently not visible or only partially visible at the top
    if (this.hasScrolledPastMainButton && hasScrolledPastTop) {
      this.stickyContainer.classList.add('is-visible');
    } else {
      this.stickyContainer.classList.remove('is-visible');
      
      // If the button is fully visible again (e.g., user scrolled back up),
      // we need to reset our tracking
      if (buttonRect.top >= 0 && buttonRect.bottom <= windowHeight) {
        this.hasScrolledPastMainButton = false;
      }
    }
  }

  updateStickyButton(event) {
    if (!this.stickyAddToCartBtn || !this.stickyPrice) return;
    
    // Get the current variant from the event
    const variant = event.detail.variant;
    
    if (variant) {
      // Update price
      if (variant.price) {
        // Format the price - this is simplified, adjust as needed for your currency format
        const formattedPrice = this.formatMoney(variant.price);
        this.stickyPrice.textContent = formattedPrice;
      }
      
      // Update button state based on availability
      this.stickyAddToCartBtn.disabled = !variant.available;
      this.stickyAddToCartBtn.dataset.variantId = variant.id;
      
      // Update button text
      const buttonTextSpan = this.stickyAddToCartBtn.querySelector('.button__text');
      if (buttonTextSpan) {
        buttonTextSpan.textContent = variant.available ? 
          window.theme.strings.addToCart || 'Add to cart' : 
          window.theme.strings.soldOut || 'Sold out';
      }
    }
  }

  addToCart(event) {
    event.preventDefault();
    
    // If we have a main add to cart button, simulate a click on it
    if (this.mainAddToCartBtn) {
      this.mainAddToCartBtn.click();
      return;
    }
    
    // Fallback if main button doesn't exist or click doesn't work:
    // Get the current variant ID from the button
    const variantId = this.stickyAddToCartBtn.dataset.variantId;
    
    if (!variantId) return;
    
    // Show loading state
    this.stickyAddToCartBtn.classList.add('is-loading');
    
    // Add to cart via AJAX
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    
    fetch(window.theme.routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // Success - update cart and show notification if needed
      this.stickyAddToCartBtn.classList.remove('is-loading');
      
      // Trigger cart update
      if (window.theme && window.theme.updateCart) {
        window.theme.updateCart();
      }
      
      // Open cart drawer if available
      if (window.theme && window.theme.openCartDrawer) {
        window.theme.openCartDrawer();
      }
    })
    .catch(error => {
      // Handle error
      console.error('Error adding to cart:', error);
      this.stickyAddToCartBtn.classList.remove('is-loading');
    });
  }

  formatMoney(cents) {
    // Basic money formatter - adjust based on your theme's currency formatting
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    const value = parseInt(cents || 0, 10);
    const dollars = Math.floor(value / 100);
    const cents_part = (value % 100).toString().padStart(2, '0');
    
    return '$' + dollars + '.' + cents_part;
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  new StickyAddToCart();
}); 